<template>
  <div class="sm-auth__template-form">
    <h3 class="sm-txt-center">Send temporary password</h3>
    <form 
      class="sm-auth__main-form" 
      @submit.prevent="handleSubmit"
    >
      <input-text
        v-model="email"
        :value="email"
        :label="'Email'"
        :name="'email'"
        v-validate="`required|email`"
        data-vv-as="email"
        :error="errors.first('email') || errors.first('back_errors')"
        :showLoader="showLoader"
        :isEmail="true"
      />
      <p 
        v-if="errors.first('email') == ' '"
        class="sm-auth__main-form-email-error sm-small"
      >
        <include-svg :name="'icon-attention'" />
        <span>No account exists for <b class="sm-txt-strong">{{email}}</b>. Maybe you signed up using a different/incorrect e-mail address.</span>
      </p>
      <btn-block :text="'Send password'" type="submit" />
    </form>
    <router-link :to="{ name: 'login' }" class="sm-link sm-link-blue">Log in</router-link>

    <div
      v-if="showSuccess" 
      class="sm-auth__main-reset-success"
    >
      <include-svg :name="'icon-check-circle'" />
      <h3>Check your email to get temporary password</h3>
      <a
        href="#"
        class="sm-auth__main-reset-success-link"
        @click.prevent="$router.push('/login')"
      >
        <include-svg :name="'icon-back-sys'" />
        <span>Back to Sign in</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import InputText from '@/components/InputText';

export default {
  name: 'reset-password',
  data() {
    return {
      email: '',
      submitted: false,
      showLoader: false,
      showSuccess: false
    };
  },
  created() {
    this.Logout();
  },
  components: {
    'input-text': InputText
  },
  methods: {
    ...mapActions({
      ResetPassword: 'auth/resetPassword',
      Logout: 'auth/logout',
      showGlobalNotification: 'showGlobalNotification'
    }),
    handleSubmit(e) {
      this.submitted = true;

      this.$validator.validate()
        .then(valid => {
          if (!valid) 
            return false;

          this.showLoader = true;
          this.ResetPassword(this.email)
            .then(() => {
              // this.showGlobalNotification({
              //   type: 'notification',
              //   value: ['Check your email']
              // });
              this.showSuccess = true;
              this.showLoader = false;
            })
            .catch(e => {
              const err = e.response;

              if (err.status === 500) {
                this.errors.add({
                  field: 'back_errors',
                  msg: err.data.error
                });
              } else {
                const messages = err.data.errors;

                if (messages.email) {
                  this.errors.add({
                    field: 'email',
                    msg: ' '//messages.email[0]
                  });
                } else if (messages.base) {
                  messages.base.forEach(item => {
                    this.errors.add({
                      field: 'back_errors',
                      msg: item
                    });
                  });
                }
              }

              this.showLoader = false;
            });
          });
    }
  },
  watch: {
    // TEMP
    email: {
      handler() {
        this.errors.remove('back_errors');
      },
      deep: true
    }
  }
};
</script>
